/* js for ap featured product */

var fp_id_popup = "137";

var fp_disable_url = "";

var fp_init_delay = 1000;

var fp_options = {

  time_to_show : 500, 

  time_display : 3000, 

  time_to_hide : 500, 

  hover_pause : false,

  time_between : 2000,

  loop : 1,

  close_button : 1,

};

jQuery("#ap-fp-137").hover(function(){options.hover_pause = true;}, function(){options.hover_pause = false;});

